import { Component, Input, TemplateRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-note-history-list',
  templateUrl: './note-history-list.component.html',
  styleUrls: ['./note-history-list.component.scss']
})
export class NoteHistoryListComponent {
  template: TemplateRef<HTMLElement>;
  detailsList: any;
  public dateTimeDisplay = environment.dateTimeDisplay;
  @Input() title;
  @Input() historyHeader;

  constructor(public bsModalRef: BsModalRef) {}

  decline(): void {
    this.bsModalRef.hide();
  }
}
